/*
 * decaffeinate suggestions:
 * DS002: Fix invalid constructor
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS103: Rewrite code to no longer use __guard__, or convert again using --optional-chaining
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';
import immutable from 'object-path-immutable';
import isemail from 'isemail';
import classNames from 'classnames';
import * as Utilities from '../../utilities';

export class AttendeeDetailForm extends React.Component {
        static initClass() {
          this.propTypes = {
            // List of additional questions
            questions: PropTypes.array,
            // List of answers to the above questions, in order
            answers: PropTypes.object,
            errors: PropTypes.object,
            name: PropTypes.string,
            email: PropTypes.string,
            onChange: PropTypes.func,
            attendee_sms_enabled: PropTypes.bool
          };
  
          this.defaultProps = {
            questions: [],
            answers: {},
            errors: {},
            attendee_sms_enabled: false
          };
        }

        constructor(props) {
          super(props);
          this._validateInput = this._validateInput.bind(this);
          this.onChange = this.onChange.bind(this);
          this.renderRequired = this.renderRequired.bind(this);
          this.renderTextFieldElement = this.renderTextFieldElement.bind(this);
this.renderSelectElement = this.renderSelectElement.bind(this);

          this.state = {
            // Value is non-null when the input field named "key" has an error (blank but required, or invalid format)
            errors: {},
            // Each value is true when the input field named "key" has been modified
            dirty: {}
          };

          // Mark answered fields as dirty
          for (const key in props.answers) {
            this.state.dirty[key] = true;
          }

          // Name and email are linked, if one is dirty treat both as dirty
          if (this.state.dirty['email'] || this.state.dirty['name']) {
            this.state.dirty['email'] = true;
            this.state.dirty['name'] = true;
          }

          // Validate input needs the state initialized first
          const new_errors = this._validateInput(props);
          this.state.errors = new_errors;
        }

        // When we receive new props, update any error states
        UNSAFE_componentWillReceiveProps(nextProps) {
          if (nextProps.errors !== this.props.errors) {
            // Replace error state with a copy of what we were given
            this.setState({errors: _.extend({}, nextProps.errors)});

            // And mark any fields as dirty that have errors
            let new_dirty = this.state.dirty;

            for (const key in nextProps.errors) {
              new_dirty = immutable.set(new_dirty, String(key), true);
            }

            return this.setState({dirty: new_dirty});

          } else if (nextProps.answers !== this.props.answers) {
            const new_errors = this._validateInput(nextProps);
            return this.setState({errors: new_errors});
          }
        }

        // Validate input
        // 
        // When +force+ is true, validates all fields, otherwise only
        // those fields that have been modified or are currently in an error state 
        // are validated.
        _validateInput(props) {
          const new_errors = {};

          const should_validate = field => this.state.errors[field] || this.state.dirty[field];

          // Validate presence of name and email
          for (const key of ['name', 'email']) {
            if (should_validate(key) && Utilities.isBlank(props.answers != null ? props.answers[key] : undefined)) { new_errors[key] = 'required'; }
          }

          // Validate format of email
          if (should_validate('email') && (props.answers != null ? props.answers['email'] : undefined) && !isemail.validate(props.answers != null ? props.answers['email'] : undefined)) { new_errors['email'] = 'invalid_format'; }

          // Validate format of phone number
          // This is intentionally a looser check than we perform on the server, allowing common delimiters and spaces
          if (should_validate('phone_number') && __guard__(props.answers != null ? props.answers['phone_number'] : undefined, x => x.match(/[^0-9 ,.()+-]/))) { new_errors['phone_number'] = 'invalid_format'; }

          for (var question of Array.from(props.questions)) {
            if (!question.required) { continue; }
            if (should_validate(question.id) && Utilities.isBlank(__guard__(props.answers != null ? props.answers.answers : undefined, x1 => x1[question.id]))) { new_errors[question.id] = 'required'; }
          }

          return new_errors;
        }

        onChange(event) {
          let index; let name;
          this.setState({dirty: immutable.set(this.state.dirty, event.target.name, true)});

          switch (event.target.name) {
            case 'name': case 'email': case 'phone_number':
              ({
                name
              } = event.target);
              index = null;
              break;
            default:
              name = 'answers';
              index = Number(event.target.name);
          }

          return (typeof this.props.onChange === 'function' ? this.props.onChange(name, index, event.target.value) : undefined);
        }

        renderRequired() {
          return <span className='required'>REQUIRED</span>;
        }

        renderTextFieldElement(classes, error_message, question, value, describedby, form_key) {
          return <div className={error_message ? "em-input-floating em-error" : "em-input-floating"}>
            <input key={question.id}
                   id={form_key}
                   aria-describedby={describedby}
                   type="text"
                   className={classes}
                   onChange={this.onChange}
                   name={question.id}
                   value={value}
                   required={question.required}
                   placeholder={question.question}/>
            <label htmlFor={form_key}>
              {question.question}
              {question.required && this.renderRequired()}
            </label>
          </div>;
        }

        renderSelectElement(classes, error_message, question, value, describedby, form_key) {
          const choices = _.map(question.choices, (choice, index) => <option key={index} value={choice}>{choice}</option>);

          const klasses = classNames('em-select-floating', {
                               'em-error': !!error_message,
                               'em-select-floating--placeholder': (value === "") || (value === undefined)
                             }
          );

          return <div className={klasses}>
            <label htmlFor={form_key}>
              {question.question}
              {question.required && this.renderRequired()}
            </label>
            <select name={question.id}
                    id={form_key}
                    aria-describedby={describedby}
                    className={classes}
                    onChange={this.onChange}
                    value={value}
                    required={question.required}>
              <option key="0" value="" disabled={question.required} selected={true}></option>
              {choices}
            </select>
            <i className="fas fa-sort-down"></i>
          </div>;
        }

        renderQuestionRows(form_key) {
          return (() => {
            const result = [];
            for (const index in this.props.questions) {
              var classes;
              var question = this.props.questions[index];
              const error_message = this.state.errors[question.id] ?
                `You must answer ${question.question}` : undefined;

              if (this.state.errors[question.id]) { classes = "error_marker"; }
              const value = __guard__(this.props.answers != null ? this.props.answers.answers : undefined, x => x[question.id]);
              const describedby = `${form_key}-attendee-question-${question.id}-error`;
              const question_form_key = `${form_key}-attendee-question-${question.id}`;

              const response_element =  question.response_type === "dropdown" ?
                                    this.renderSelectElement(classes, error_message, question, value, describedby, question_form_key)
                                  :
                                    this.renderTextFieldElement(classes, error_message, question, value, describedby, question_form_key);

              result.push( <div className="em-input_container" key={index}>
                  {response_element}
                  {error_message && <span className="error_marker" id={describedby}>{error_message}</span>}
                </div>);
            }
            return result;
          })();
        }

        render() {
          if (!this.props.item) { return null; }

          const header_text = `${this.props.item.name} Attendee #${this.props.index}`;
          const form_key = `${this.props.item.ticket_class_id}-${this.props.index}`;
        
          return <div key={`${this.props.item.ticket_class_id  }-${  this.props.index}`}>
            <div className="em-attendee_info">
              <div className="em-input_container ">
                <div className={this.state.errors.name == 'required' ? "em-input-floating error" : "em-input-floating"}>
                  <input type="text"
                         id={`${form_key  }-attendee-name`}
                         aria-describedby={`${form_key  }-attendee-name-error`}
                         name="name"
                         autoComplete="name"
                         required="required"
                         onChange={this.onChange}
                         value={this.props.answers['name']}
                         placeholder="Full Name REQUIRED"/>
                  <label htmlFor={`${form_key  }-attendee-name`}>
                    Full Name {this.renderRequired()}
                  </label>
                </div>
                {this.state.errors.name == 'required' &&
                  <span className="error_marker" role="alert" id={`${form_key  }-attendee-name-error`}>The attendee name is required</span>}
              </div>
              <div className="em-input_container">
                <div
                  className={(this.state.errors.email == 'invalid_format' || this.state.errors.email == 'required') ? "em-input-floating em-error" : "em-input-floating"}>
                  <input type="text"
                         id={`${form_key  }-attendee-email`}
                         aria-describedby={`${form_key  }-attendee-email-error`}
                         name="email"
                         required="required"
                         autoComplete="email"
                         onChange={this.onChange}
                         value={this.props.answers['email']}
                         placeholder="Email Address REQUIRED"/>
                  <label htmlFor={`${form_key  }-attendee-email`}>
                    Email Address {this.renderRequired()}
                  </label>
                </div>
                {this.state.errors.email == 'required' &&
                  <span className="error_marker" role="alert" id={`${form_key  }-attendee-email-error`}>The attendee email is required</span>}
                {this.state.errors.email == 'invalid_format' &&
                  <span className="error_marker" role="alert" id={`${form_key  }-attendee-email-error`}>That is not a valid email</span>}
              </div>
              {this.props.attendee_sms_enabled && <>
                <span className="em-input_container em-phone_number_disclaimer">
                  By submitting phone numbers here, your attendees will receive updates about events they&#39;re attending or interested in, and you confirm you have authorization from each attendee to provide their number. They will receive a text to confirm ownership. Carrier fees may apply.
                </span>
                <div className="em-input_container">
                  <div
                    className={(this.state.errors.phone_number == 'invalid_format') ? "em-input-floating em-error" : "em-input-floating"}>
                    <input type="text"
                          id={`${form_key  }-attendee-phone-number`}
                          aria-describedby={`${form_key  }-attendee-phone-number`}
                          name="phone_number"
                          autoComplete="tel"
                          onChange={this.onChange}
                          value={this.props.answers['phone_number']}
                          placeholder="Phone Number"/>
                    <label htmlFor={`${form_key  }-attendee-phone-number`}>
                      Phone Number
                    </label>
                  </div>
                  {this.state.errors.phone_number == 'invalid_format' &&
                    <span className="error_marker" role="alert" id={`${form_key  }-attendee-phone-number-error`}>That is not a valid phone number</span>}
                </div>
              </>}
            </div>


            {this.renderQuestionRows(form_key)}
          </div>;
        }
      }
AttendeeDetailForm.initClass();

function __guard__(value, transform) {
  return (typeof value !== 'undefined' && value !== null) ? transform(value) : undefined;
}